import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {NotificationService} from '../services/notification.service';

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const notification = inject(NotificationService);

  if (auth.isSuperAdmin()) {
    return true;
  }

  notification.error('Access denied. This section requires Super Admin privileges.');
  return router.createUrlTree(['/dashboard']);
};
